import React, { Suspense } from 'react';
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromChildren,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import { PageLoader, Tooltip } from '../views/components';
import history from './history';
import routesConfig from './routes.config';
import { MeSelectors } from '../redux/selectors';
import ErrorBoundary from '../views/pages/ErrorBoundary';

const AppRouter = () => {
  const me = useSelector(MeSelectors.selectMe);
  const router = createBrowserRouter(
    createRoutesFromChildren(routesConfig.map((route) => {
      const { props: componentProps = {} } = route;
      return (
        <Route
          key={route.path}
          path={route.path}
          props={route.props}
          errorElement={<ErrorBoundary />}
          element={(
            <route.matcher route={route}>
              <route.layout history={history}> {/* TODO: remove history after merging class components */}
                <Suspense fallback={<PageLoader />}>
                  <route.component
                    {...componentProps}
                    me={me}
                    history={history} // TODO: remove history after merging class components
                  />
                  <PageLoader />
                  <Tooltip />
                </Suspense>
              </route.layout>
            </route.matcher>
          )}
        />
      );
    })),
  );
  return <RouterProvider router={router} />;
};

export default AppRouter;
